import React from 'react'
import { Col as ModernCol } from 'react-bootstrap'

const ColShim = ({
  xs,
  sm,
  md,
  lg,
  xsOffset,
  smOffset,
  mdOffset,
  lgOffset,
  xsPush,
  smPush,
  mdPush,
  lgPush,
  xsPull,
  smPull,
  mdPull,
  lgPull,
  ...props
}: any) => {
  // Helper to merge old offset/push/pull into the modern object-style prop
  const transform = (val: any, offset: any, push: any, pull: any) => {
    if (!offset && !push && !pull) return val

    const obj: any = {}
    if (val !== undefined) obj.span = val
    if (offset !== undefined) obj.offset = offset
    // Note: 'push' and 'pull' were replaced by 'order' in Bootstrap 5
    if (push !== undefined) obj.order = 'last'
    if (pull !== undefined) obj.order = 'first'

    return obj
  }

  const newProps = {
    xs: transform(xs, xsOffset, xsPush, xsPull),
    sm: transform(sm, smOffset, smPush, smPull),
    md: transform(md, mdOffset, mdPush, mdPull),
    lg: transform(lg, lgOffset, lgPush, lgPull)
  }

  return <ModernCol {...props} {...newProps} />
}

export default ColShim
